import * as Types from '../../../generated/gqlTypes';

import { gql } from '@apollo/client';
export type ShippingBaseFragment = { id: string, pk: number, name: string, isPhoneRequired: boolean, active: boolean };

export const ShippingBaseFragmentDoc = gql`
    fragment ShippingBaseFragment on ShippingMethodType {
  id
  pk
  name
  isPhoneRequired
  active
}
    `;